import ReactPaginate from "react-paginate";

const Pagination = ({ pagesCount, action }) => {
	return <>
		{pagesCount ?
			<div className="card mb-3">
				<div className="card-body bg-light">
					<ReactPaginate
						pageCount={pagesCount}
						pageRangeDisplayed={3}
						marginPagesDisplayed={2}
						previousLabel={<i className="fa fa-angle-left"></i>}
						nextLabel={<i className="fa fa-angle-right"></i>}
						breakLabel="..."
						onPageChange={e => action(e.selected + 1)}
						renderOnZeroPageCount={null}
						className="pagination pagination-sm justify-content-center mb-0 ltr"
						pageClassName="page-item"
						pageLinkClassName="page-link"
						activeClassName="active"
						previousClassName="page-item"
						previousLinkClassName="page-link"
						nextClassName="page-item"
						nextLinkClassName="page-link"
						breakClassName="mx-2"
					/>
				</div>
			</div>
		: ''}
	</>
};

export default Pagination;
